// `data-confirm="Question?"` on a button or link asks the question first and
// cancels the click (so also the form submission) unless it is answered with
// OK. Listens in the capture phase to be ahead of everything else. Turbo
// forms can use Turbo's own `data-turbo-confirm` on the form instead.
document.addEventListener(
  "click",
  (event) => {
    const element = event.target.closest?.("[data-confirm]");
    if (!element) return;
    if (!window.confirm(element.dataset.confirm)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
